module.exports = "/assets/data/7dfbd986345606c26ca24830bbc7d42b-B12.data.json";